import './styles_2.less'
import { ChangeEvent, useContext, useEffect, useState } from "react"
import gql from "graphql-tag"
import { useQuery } from "@apollo/client"
import { formatMoney } from "@Utils/Functions"
import ButtonGroup from '../ButtonGroup/web'
import { validateRange } from 'src/utils/Functions'
import { CloseIcon } from 'shared-components/Components/CustomIcons/CloseIcon/web'
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context'
import CheckboxCustomInput from 'shared-components/Components/CheckboxCustomInput'
import { currenciesByCountry } from 'shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/options'
import { usePendingFilters } from 'shared-components/Contexts/PendingFilters/PendingFiltersContext'
import { useWindowSize } from 'shared-components/GlobalHooks/useWindowSize'
import { useSearchResultsFilters } from 'shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook'

const QUERY_PRICE_FILTER_OPTIONS = gql`{
    availableFilters{
      price{id name options}
    }
}`

/* @TODO - este componente es un refactoreo del original, revisar que no le falte ninguna funcionalidad */

export const Price = ({showTitle = true, showCta = false, changeFilters, filters, show, verticalOptions = false}) => {
    if (!show) return null;

    const {data:availableFililter} = useQuery(QUERY_PRICE_FILTER_OPTIONS,{ssr:false})
    const {country_code, translations} = useContext(ConfigStateContext);
    const { setPendingFilter } = usePendingFilters();
    const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
    const screens = useWindowSize()
    const [selectedCurrency, setSelectedCurrency] = useState<number>(filters.currencyID);
    const [priceRange, setPriceRange] = useState({ minPrice:filters?.minPrice, maxPrice:filters?.maxPrice });
    const [showCommonExpenses, setShowCommonExpenses] = useState(false);
    const [commonExpenses, setCommonExpenses] = useState(filters?.commonExpenses);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const priceOptions = availableFililter?.availableFilters?.price?.options ?? [];

    const isMobile =  !screens.xl && !screens.lg;

    useEffect(() => {
        setCommonExpenses(filters?.commonExpenses)
    }, [filters?.commonExpenses])

    useEffect(()=>{        
        setSelectedCurrency(filters?.currencyID)
    },[filters?.currencyID])

    useEffect(() => {
        if (filters.operation_type_id === 2) setShowCommonExpenses(true);
        else setShowCommonExpenses(false)

        if (country_code && !(filters?.minPrice || filters?.maxPrice)) {
            const currency = currenciesByCountry[country_code];

            const defCurr = currency.filter((c) => c.defaultOperationType.includes(filters.operation_type_id))[0]
            const defaultCurrency = defCurr ? defCurr : currency[0];

            setSelectedCurrency(defaultCurrency.value);
        }
    }, [filters?.operation_type_id])

    useEffect(() => {
        if (filters?.minPrice) {
            setPriceRange((range) => ({...range, minPrice: filters?.minPrice}));
        } else {
            setPriceRange((range) => ({...range, minPrice: ""}));
        }

        if (filters?.maxPrice) {
            setPriceRange((range) => ({...range, maxPrice: filters?.maxPrice}));
        } else {
            setPriceRange((range) => ({...range, maxPrice: ""}));
        }
    }, [filters.minPrice, filters.maxPrice])
    
    const currencyChanged = (value) => {
        setSelectedCurrency(value)
        updateFilters({currencyID: value})
    }

    const currenySymbol = (id:number) => priceOptions.filter(c => c.id == id)[0]?.nombre ?? '';

    const updateFilters = ({ currencyID = null, currentCommonExpenses = null } = {}) => {
        const currency = {
            simbol: currenySymbol(currencyID ?? selectedCurrency),
            value: currencyID ?? selectedCurrency
        }

        const error = validateRange(priceRange.minPrice, priceRange.maxPrice, 'El precio mínimo no puede ser mayor al precio máximo');
        setErrorMessage(error)

        if(error !== '') {
            return;
        }

        let newFilters:any = {
            currencyID: { text: currency.simbol, value: currency.value },
            minPrice: (priceRange.minPrice && priceRange.minPrice > 0) ? {
                text: `Desde ${currency.simbol} ${formatMoney(priceRange.minPrice)}`,
                value: priceRange.minPrice
            }: null,
            maxPrice: (priceRange.maxPrice && priceRange.maxPrice > 0) ? {
                text: `Hasta ${currency.simbol} ${formatMoney(priceRange.maxPrice)}`,
                value: priceRange.maxPrice
            }: null,
            commonExpenses: (currentCommonExpenses || commonExpenses) ? {
                text: "Incluyendo Gastos Comunes", 
                value: currentCommonExpenses ?? commonExpenses
            } : null
        }

        setErrorMessage(validateRange(priceRange.minPrice, priceRange.maxPrice, 'El precio mínimo no puede ser mayor al precio máximo'));
        changeFilters(newFilters);
    }

    const commonExpChanged = (e:ChangeEvent<HTMLInputElement>) => {
        let newVal = e.target.checked

        setCommonExpenses(newVal)

        if (
            (priceRange.minPrice ||
            priceRange.maxPrice) ||
            !newVal
        ) updateFilters({currentCommonExpenses: newVal});
    }

    const handleMinPrice = (e) => {
        const inputNum = e.target.value.replace(/\D/g, '')
        const formattedNum = formatMoney(inputNum)

        setPriceRange((prevState) => ({
          ...prevState,
          minPrice: Number(inputNum),
        }));

        e.target.value = formattedNum
    }
    
    const handleMaxPrice = (e) => {
        const inputNum = e.target.value.replace(/\D/g, '')
        const formattedNum = formatMoney(inputNum)

        setPriceRange((prevState) => ({
            ...prevState,
            maxPrice: Number(inputNum),
        }));

        e.target.value = formattedNum
    }

    const handleCleanRange = (type) => {
        setPriceRange((prevState) => ({
            ...prevState,
            [type]: null,
        }));

        const newFilters = {
            [type]: null
        };

        changeFiltersAndUpdateURL(newFilters);
    }

    // Función para guardar filtros pendientes en mobile
    const savePendingPriceFilters = () => {
        if (isMobile) {
            const currency = {
                simbol: currenySymbol(selectedCurrency),
                value: selectedCurrency
            }

            const error = validateRange(priceRange?.minPrice, priceRange?.maxPrice, 'El precio mínimo no puede ser mayor al precio máximo');
            if (error !== '') {
                setErrorMessage(error);
                return;
            }

            const pendingPriceFilters = {
                currencyID: { text: currency.simbol, value: currency.value },
                minPrice: (priceRange?.minPrice && priceRange?.minPrice > 0) ? {
                    text: `Desde ${currency.simbol} ${formatMoney(priceRange?.minPrice)}`,
                    value: priceRange?.minPrice
                }: null,
                maxPrice: (priceRange?.maxPrice && priceRange?.maxPrice > 0) ? {
                    text: `Hasta ${currency.simbol} ${formatMoney(priceRange?.maxPrice)}`,
                    value: priceRange?.maxPrice
                }: null,
                commonExpenses: commonExpenses ? {
                    text: "Incluyendo Gastos Comunes", 
                    value: commonExpenses
                } : null
            };

            setPendingFilter('price', pendingPriceFilters);
            setErrorMessage('');
        }
    };

    return <div className="filter price-filter">
        {showTitle && <h3 className="filter-title">Precio</h3>}

        <div className="price-filter__box">
            {
                (filters?.operation_type_id !== 1 &&
                country_code !=='CO' &&
                priceOptions.length > 1) || country_code === 'PY' ? (
                    <ButtonGroup
                        options={priceOptions.map(currency =>{return {text: currency.nombre, value: currency.id}})}
                        selected={[selectedCurrency]}
                        allowMuliple={false}
                        onChange={currencyChanged}
                        isSmall
                    />
                ) 
            : null }

            <div className={`priceRange ${verticalOptions ? 'priceRange--col' : ''}`}>
                <div className='priceRange__box'>
                    <input
                        type="text"
                        inputMode="numeric"
                        value={priceRange.minPrice?formatMoney(priceRange.minPrice):''}
                        placeholder={`Min ${currenySymbol(selectedCurrency)}`}
                        onChange={handleMinPrice}
                        onBlur={() => {
                            // En mobile, no actualizar automáticamente en onBlur
                            if (!isMobile) {
                                const equalValue = priceRange.minPrice === filters?.minPrice;
                                if (priceRange.minPrice !== "" && !equalValue) updateFilters();
                            }else{
                                (savePendingPriceFilters && setPendingFilter) &&  savePendingPriceFilters();
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && priceRange.minPrice !== "") {
                                if (isMobile && setPendingFilter) {
                                    savePendingPriceFilters();
                                } else {
                                    updateFilters();
                                }
                            }
                        }}
                    />

                    <button
                        className={`priceRange__box-clear ${!priceRange.minPrice ? "hidden" : ""}`}
                        style={{padding: 5}}
                        onClick={() => handleCleanRange('minPrice')}
                    >
                        <CloseIcon width={10} />
                    </button> 
                </div>

                {!verticalOptions && <span>-</span>}

                <div className='priceRange__box'>
                    <input
                        type="text" 
                        inputMode="numeric"
                        value={priceRange.maxPrice?formatMoney(priceRange.maxPrice):''}
                        placeholder={`Max ${currenySymbol(selectedCurrency)}`}
                        onChange={handleMaxPrice}
                        onBlur={() => {
                            // En mobile, no actualizar automáticamente en onBlur
                            if (!isMobile) {
                                const equalValue = priceRange.maxPrice === filters?.maxPrice;
                                if (priceRange.maxPrice !== "" && !equalValue) updateFilters();
                            }else{
                              (savePendingPriceFilters && setPendingFilter) &&  savePendingPriceFilters();
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && priceRange.maxPrice !== "") {
                                if (isMobile && setPendingFilter) {
                                    savePendingPriceFilters();
                                } else{
                                    (savePendingPriceFilters && setPendingFilter) &&  savePendingPriceFilters();
                                }
                            }
                        }}
                    />
                    
                    <button
                        className={`priceRange__box-clear ${!priceRange.maxPrice ? "hidden" : ""}`}
                        style={{padding: 5}}
                        onClick={() => handleCleanRange('maxPrice')}
                    >
                        <CloseIcon width={10} />
                    </button>
                </div>
            </div>

            {errorMessage && <p className="error-message">{errorMessage}</p>}
            
            {showCommonExpenses && (
                <CheckboxCustomInput name="compnExp" checked={commonExpenses ?? false} onChange={commonExpChanged} >
                    {translations.gastosComunesDesc}
                </CheckboxCustomInput>
            )}

            {showCta &&
                <button
                    className='priceRangeFilter__submitButton mainSubmitButton inputFilterBox__content--close'
                    onClick={() => isMobile ? savePendingPriceFilters() : updateFilters()}
                    disabled={priceRange.minPrice === "" && priceRange.maxPrice === ""}
                >
                    Aplicar rango
                </button>
            }
        </div>

        <hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
    </div>
}

